'use client'

import { useUrlParams } from '@/hooks/useUrlParams'

export function UtmCapture() {
    useUrlParams()
    return null
}
